export const INPUT_ID = 'Input';
export const GROUP_ID = 'InputGroup';
export const PREFIX_ID = 'InputPrefix';
export const SUFFIX_ID = 'InputSuffix';
export const DEFAULT_INPUT_ROLE = 'textbox';
export const INPUT_SIZES = {
    default: 'default',
    lg: 'lg',
} as const;
